import React, { useEffect, useMemo, useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import PretendardText from "../../../component/atoms/text/pretendardText";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import TableTop from "./../../../component/atoms/layout/table/tableTop";
import TableCount from "./../../../component/molecules/tableCount";
import SearchBar from "./../../../component/atoms/input/searchBar";
import { route } from "./../../../router/route";
import Pagination from "./../../../component/molecules/pagination";
import scrollToTop from "../../../util/scrollToTop";
import DetailBtn from "../../../component/atoms/button/detailBtn";
import Td from "../../../component/atoms/layout/table/td";
import TableText from "../../../component/atoms/text/table/tableText";
import Table from "../../../component/atoms/layout/table/table";
import Tr from "./../../../component/atoms/layout/table/tr";
import Th from "./../../../component/atoms/layout/table/th";
import Checkbox from "./../../../component/atoms/input/checkbox";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import { errorHandler } from "../../../util/errorHandler";
import RedBtn from "./../../../component/atoms/button/redBtn";
import Modal from "./../../../component/templates/Modal";
import EventBtn from "../../../component/atoms/button/eventBtn";
import PopupApi from "../../../api/popup.api";
import moment from "moment";

// TODO:
// - 삭제 API 500 에러 나는거 확인 필요
// - 상태 필터링 어떻게 할건지 얘기하기

const OperationPopupBanner = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [keyword, setKeyword] = useState("");
  const [activationFilter, setActivationFilter] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  // ---------- 쓰기 권한체크 ---------- //
  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.operation_popup_banner)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
    setActivationFilter(
      searchParams.get("activation") === "false" ? false : true
    );
    getPopupList();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 페이지네이션 관련 ---------- //
  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
  });

  // ---------- 팝업 리스트 가져오기 ---------- //
  const [popupList, setPopupList] = useState([]);

  const getPopupList = async () => {
    try {
      const data = {
        page: page,
        size: pagination.size,
        saveStatus: "Y",
      };

      if (keyword) {
        data.keyword = keyword;
      }

      if (searchParams.get("activation") === "false") {
        data.activation = "Inactive";
      }

      const response = (await PopupApi.getListPopup(data)).data.data;

      const processedData = [...response.content].map((item, index) => {
        return {
          ...item,
          numbering: response.totalCount - (page - 1) * pagination.size - index,
          checked: false,
          isInfinity:
            moment(item.endDate).format("YYYY-MM-DD") === "9999-12-31",
        };
      });

      setPopupList(processedData);

      setPagination({
        ...pagination,
        totalCount: response.totalCount,
        totalPages: response.totalPage || Math.ceil(response.totalCount / 10),
        first: response.first,
        last: response.last,
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 체크 관련 ---------- //
  const isAllCheck = useMemo(() => {
    const checkedList = popupList.filter((item) => item.checked);
    return checkedList.length !== 0 && checkedList.length === popupList.length;
  }, [popupList]);

  // ---------- 버튼 그룹 관련 ---------- //
  const [buttonGroupOpen, setButtonGroupOpen] = useState(false);

  useEffect(() => {
    const checkedList = popupList.filter((item) => item.checked);
    if (checkedList.length > 0) {
      setButtonGroupOpen(true);
    } else {
      setButtonGroupOpen(false);
    }
  }, [popupList]);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [delIdList, setDelIdList] = useState([]);

  const deleteFunc = async () => {
    try {
      const data = {
        ids: delIdList,
        allFlag: false,
      };
      await PopupApi.deletePopup(data);
      toast(toastMsg.delete);
      setDeleteModalOpen(false);
      setDelIdList([]);
      getPopupList();
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 활성 상태 관련 ---------- //
  const [filterOpen, setFilterOpen] = useState(false);

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>팝업/배너 관리</TableTitle>
          {/* 테이블 상단 영역 */}
          <TableTop>
            <TableCount text={"게시글"} count={pagination.totalCount} />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <SearchBar
                value={keyword}
                placeholder={"제목, 닉네임"}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    if (keyword !== "") {
                      navigate(
                        `${route.operation_popup_banner}?page=1&keyword=${keyword}`,
                        {
                          replace: true,
                        }
                      );
                    } else {
                      navigate(route.operation_popup_banner, {
                        replace: true,
                      });
                    }
                  }
                }}
                onClick={() => {
                  navigate(
                    `${route.operation_popup_banner}?page=1&keyword=${keyword}`,
                    {
                      replace: true,
                    }
                  );
                }}
              />
              {isWriteAuthority && (
                <EventBtn
                  onClick={() => navigate(route.operation_popup_banner_create)}
                  text={"팝업/배너 추가하기"}
                />
              )}
            </div>
          </TableTop>

          {/* 버튼 그룹 */}
          {buttonGroupOpen && isWriteAuthority && (
            <div
              style={{
                width: "100%",
                height: 49,
                display: "flex",
                gap: 12,
              }}
            >
              <RedBtn
                style={{
                  backgroundColor: "#272829",
                }}
                onClick={() => {
                  const delList = popupList.filter((item) => item.checked);
                  if (delList.length <= 0) {
                    return;
                  }
                  setDelIdList(delList.map((item) => item.id));
                  setDeleteModalOpen(true);
                }}
              >
                삭제
              </RedBtn>
            </div>
          )}

          {/* 테이블 영역 */}

          <Table>
            <colgroup>
              {/* 합계: 1044px */}
              {/* 체크박스 */}
              <col width="56px" />
              {/* 제목 */}
              <col width="320px" />
              {/* 상태 */}
              <col width="112px" />
              {/* 기간 */}
              <col width="170px" />
              {/* 기기 */}
              <col width="120px" />
              {/* 노출 페이지 */}
              <col width="183px" />
              {/* 보기 */}
              <col width="83px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "41px", background: "#272829" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <Checkbox
                    checked={isAllCheck}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setPopupList(
                          popupList.map((item) => {
                            return {
                              ...item,
                              checked: true,
                            };
                          })
                        );
                      } else {
                        setPopupList(
                          popupList.map((item) => {
                            return {
                              ...item,
                              checked: false,
                            };
                          })
                        );
                      }
                    }}
                  />
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    제목
                  </TableText>
                </Th>
                <Th>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      cursor: "pointer",
                      position: "relative",
                    }}
                  >
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      상태
                    </TableText>
                    <img
                      className={filterOpen === true ? "rotate" : "rotate-back"}
                      src="/assets/admin/icons/ico_arrow_down.svg"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setFilterOpen(!filterOpen);
                      }}
                      alt="필터 펼치기/접기"
                    />
                    {filterOpen && (
                      <FilterWrapper>
                        <FilterTextWrapper>
                          <FilterText
                            onClick={() => {
                              navigate(
                                `${
                                  route.operation_popup_banner
                                }?page=1&activation=${true}&keyword=${keyword}`,
                                {
                                  replace: true,
                                }
                              );

                              setFilterOpen(false);
                            }}
                          >
                            진행중
                            {activationFilter ? (
                              <img
                                src="/assets/admin/icons/ico_selectbox_checked.svg"
                                alt="선택됨"
                              />
                            ) : null}
                          </FilterText>
                        </FilterTextWrapper>
                        <FilterText
                          onClick={() => {
                            navigate(
                              `${
                                route.operation_popup_banner
                              }?page=1&activation=${false}&keyword=${keyword}`,
                              {
                                replace: true,
                              }
                            );

                            setFilterOpen(false);
                          }}
                        >
                          종료
                          {activationFilter ? null : (
                            <img
                              src="/assets/admin/icons/ico_selectbox_checked.svg"
                              alt="선택됨"
                            />
                          )}
                        </FilterText>
                      </FilterWrapper>
                    )}
                  </div>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    기간
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    기기
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    노출 페이지
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    보기
                  </TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {popupList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{
                      height: "82px",
                      background: "transparent",
                      borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                    }}
                  >
                    <Td style={{ paddingLeft: "20px" }}>
                      <Checkbox
                        checked={item.checked}
                        onChange={() => {
                          item.checked = !item.checked;
                          setPopupList([...popupList]);
                        }}
                      />
                    </Td>
                    {/* 제목 */}
                    <Td>
                      <TableText
                        style={{
                          maxWidth: "272px",
                        }}
                      >
                        {item?.title || ""}
                      </TableText>
                    </Td>
                    {/* 상태 */}
                    <Td>
                      <TableText
                        style={{
                          color: `${
                            item.activation
                              ? "#009bde"
                              : "rgba(181, 181, 181, 0.5)"
                          }`,
                        }}
                      >
                        {item.activation ? "진행중" : "종료"}
                      </TableText>
                    </Td>
                    {/* 기간 */}
                    <Td>
                      {item.isInfinity ? (
                        <TableText>기간 제한 없음</TableText>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <TableText>
                            {moment(item.startDate).format("YYYY-MM-DD")} 부터
                          </TableText>
                          <TableText>
                            {moment(item.endDate).format("YYYY-MM-DD")} 까지
                          </TableText>
                        </div>
                      )}
                    </Td>
                    {/* 기기 */}
                    <Td>
                      <TableText>
                        {item.deviceType.map((device, index) => {
                          return (
                            <React.Fragment key={index}>
                              {`${device}${
                                index !== item.deviceType.length - 1 ? ", " : ""
                              }`}
                            </React.Fragment>
                          );
                        })}
                      </TableText>
                    </Td>
                    {/* 노출 페이지 */}
                    <Td>
                      <TableText
                        style={{
                          maxWidth: "146px",
                        }}
                      >
                        {item.exposeTitle}
                      </TableText>
                    </Td>
                    {/* 보기 */}
                    <Td>
                      <DetailBtn
                        onClick={() => {
                          navigate(
                            `${route.operation_popup_banner_edit}/${item.id}`
                          );
                          scrollToTop();
                        }}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          {/* 페이지네이션 영역 */}
          <Pagination
            route={route.operation_popup_banner}
            queryString={
              keyword ? `keyword=${searchParams.get("keyword")}` : ""
            }
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
            first={pagination.first}
            last={pagination.last}
          />
        </DetailPageLayout>
      </MainLayout>

      {deleteModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setDeleteModalOpen}
          onClick={deleteFunc}
        />
      )}
    </>
  );
};

export default OperationPopupBanner;

const FilterWrapper = styled.div.attrs((props) => {})`
  padding: 10px;
  border-radius: 3px;
  background: #272829;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 48px;
  z-index: 5;
`;

const FilterTextWrapper = styled.div.attrs((props) => {})`
  display: flex;
  gap: 1px;
`;

const FilterText = styled(PretendardText).attrs((props) => {})`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  color: #aaa;
  font-size: 15px;
  font-weight: 500;
  line-height: 22px;
  border-radius: 3px;
  cursor: pointer;

  &:hover {
    background: #313233;
  }
`;
